import * as $ from 'jquery';
import { IFormattingConverterObject } from './IFormattingConverterObject';
import { isNullOrEmptyString, isNullOrUndefined } from './utils/TypeUtil';

export class JQueryFormattingConverterObject implements IFormattingConverterObject {
  private readonly jQueryObject: JQuery.PlainObject;

  public constructor(jQueryObject: JQuery.PlainObject) {
    this.jQueryObject = jQueryObject;
  }

  getFontFamily(): string {
    return $(this.jQueryObject).css('font-family');
  }

  setCSS(newCss: Record<string, never>): void {
    $(this.jQueryObject).css(newCss);
  }

  hasStyleProperty(javascriptPropertyName: string): boolean {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const style = $(this.jQueryObject).prop('style');
    if (isNullOrUndefined(style)) {
      return false;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const styleProperty = style[javascriptPropertyName] as string;
    return !isNullOrEmptyString(styleProperty);
  }
}
